import React from "react";

const SelectInput = ({ name, value, options, handleChange = () => {} }) => {
  return (
    <select
      name={name}
      value={value[name]}
      onChange={handleChange}
      className="bg-white border-2 border-slate-200 text-gray-500 font-semibold capitalize text-sm rounded-lg focus:ring-0 focus:border-primary-500 block w-full p-2.5"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectInput;
